import { CompanyReportsSearchData, CompanyReportsSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'COMPANY_REPORTS_ADMINISTRATION:CLEAR_LIST',

  REQUEST_LIST: 'COMPANY_REPORTS_ADMINISTRATION:REQUEST_LIST',
  RECEIVE_LIST: 'COMPANY_REPORTS_ADMINISTRATION:RECEIVE_LIST',
  FAIL_LIST: 'COMPANY_REPORTS_ADMINISTRATION:FAIL_LIST',

  REQUEST_DELETE_COMPANY_REPORT: 'COMPANY_REPORTS_ADMINISTRATION:REQUEST_DELETE_COMPANY_REPORT',
  RECEIVE_DELETE_COMPANY_REPORT: 'COMPANY_REPORTS_ADMINISTRATION:RECEIVE_DELETE_COMPANY_REPORT',
  FAIL_DELETE_COMPANY_REPORT: 'COMPANY_REPORTS_ADMINISTRATION:FAIL_DELETE_COMPANY_REPORT'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: CompanyReportsSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: CompanyReportsSearchData[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteCompanyReport {
  public type: string = ACTION.REQUEST_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class ReceiveDeleteCompanyReport {
  public type: string = ACTION.RECEIVE_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class FailDeleteCompanyReport {
  public type: string = ACTION.FAIL_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}
